import { appWithTranslation } from 'next-i18next';

export const withSSRTranslations = (Component: React.ComponentType<any>, config: any) =>
  appWithTranslation(Component, config);
